import { render, staticRenderFns } from "./CredentialDetailing.vue?vue&type=template&id=662cf05e&scoped=true&"
import script from "./CredentialDetailing.vue?vue&type=script&lang=ts&"
export * from "./CredentialDetailing.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialDetailing.vue?vue&type=style&index=0&id=662cf05e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662cf05e",
  null
  
)

export default component.exports